import { commonImages } from '@images/common-images';
import { menuItems } from '@images/menu-items-images';

export const MENU_ITEMS = {
  lead: [
    // Lead related menu items
    {
      label: 'Leads',
      routerLink: '/leads',
      icon: menuItems?.lead_icon,
      permissions: ['lead.view', 'lead.view'],
      exact: true,
      flag: 'lead',
    },
    {
      label: 'Lead Overview',
      routerLink: '/leads/lead-overview',
      icon: menuItems?.lead_icon,
      exact: true,
      flag: 'lead_overview',
    },
    {
      label: 'Lead Parser',
      routerLink: '/leads/parser-setting',
      icon: menuItems?.lead_icon,
      permissions: ['leadparser.manage'],
      exact: true,
      flag: 'lead_parser',
    },
    {
      label: 'Tasks Overview',
      routerLink: '/tasks/tasks-overview',
      icon: commonImages?.calendar_time,
      permissions: ['task.show'],
      flag: 'task_overview',
    },
    {
      label: 'My Tasks',
      routerLink: '/tasks/my-tasks',
      icon: menuItems?.task_icon,
      permissions: ['task.my.show'],
      exact: true,
      flag: 'my_task',
    },
    // {
    //   label: 'Appointment',
    //   routerLink: '/leads/lead-appointment',
    //   icon: menuItems?.calendar_icon,
    //   exact: true,
    //   flag: 'project_appointment',
    // },
  ],
  task: [
    // Task related menu items
    {
      label: 'Tasks Overview',
      routerLink: '/tasks/tasks-overview',
      icon: commonImages?.calendar_time,
      permissions: ['task.show'],
      flag: 'task_overview',
    },
    {
      label: 'My Tasks',
      routerLink: '/tasks/my-tasks',
      icon: menuItems?.my_task_icon,
      permissions: ['task.my.show'],
      flag: 'my_task',
    },
    {
      label: 'All Task',
      routerLink: '/tasks/all-tasks',
      icon: menuItems?.clip_board_icon,
      permissions: ['task.view.all'],
      flag: 'all_task',
    },
    {
      label: 'Company Task',
      routerLink: '/tasks/company-tasks',
      icon: menuItems?.company_icon,
      permissions: ['company_task.manage'],
      flag: 'company_task',
    },
    {
      label: 'My Leads',
      routerLink: '/leads',
      icon: menuItems?.my_lead_icon,
      permissions: ['lead.manage', 'lead.view'],
      flag: 'my_leads',
    },
  ],
  setting: [
    // Setting related menu items
    {
      label: 'Office Set Up',
      routerLink: '/setting/setup/visibility',
      icon: menuItems?.office_setup_icon,
      permissions: ['setting.office.setup', 'setting.visibility.setup', 'setting.access.setup', 'setting.library.setup', 'setting.tag_manager.setup'],
      flag: 'office_set_up',
    },
    {
      label: 'Automation',
      routerLink: '/setting/workflow/flow',
      icon: menuItems?.member_ship_icon,
      permissions: ['automation.manage'],
      flag: 'automation',
    },
    {
      label: 'Matrix',
      routerLink: '/project_/matrix',
      icon: menuItems?.matrix_icon,
      permissions: ['matrix_builder.manage'],
      flag: 'matrix',
    },
    {
      label: 'Matrix (classic)',
      routerLink: '/project_/sale-board-list',
      icon: menuItems?.matrix_icon,
      permissions: ['matrix_builder.manage'],
      flag: 'matrix',
    },
    {
      label: 'Menu',
      routerLink: '/setting/menu-customisation',
      icon: menuItems?.menu_icon,
      permissions: ['menu.add', 'menu.edit', 'rolemenu.add', 'rolemenu.edit'],
      flag: 'menu',
    },
    {
      label: 'Task Set Up',
      routerLink: '/setting/tasks/job-type',
      icon: menuItems?.task_setup_icon,
      permissions: ['task.jobtype.manage', 'task.priority.manage'],
      flag: 'task_set_up',
    },
    {
      label: 'Entity Manager',
      routerLink: '/setting/entity-manager',
      icon: menuItems?.entity_manager_icon,
      permissions: ['entitymanager.manage'],
      flag: 'entity_manager',
    },
    {
      label: 'Membership',
      routerLink: '/setting/level',
      icon: menuItems?.member_ship_icon,
      permissions: ['level.manage'],
      flag: 'membership',
    },
  ],
  project: [
    // Project related menu items
    {
      label: 'Projects',
      routerLink: '/project/projects',
      icon: commonImages?.project_1_icon,
      permissions: ['allprojects.view', 'allprojects.manage'],
      flag: 'projects',
    },
    {
      label: 'Lot',
      routerLink: '/listings/lot',
      icon: commonImages?.project_1_icon,
      permissions: ['allprojects.view', 'allprojects.manage'],
      flag: 'lot',
    },
    {
      label: 'EOI',
      routerLink: '/listings/listing-eoi',
      icon: commonImages?.project_1_icon,
      permissions: ['allprojects.view', 'allprojects.manage'],
      flag: 'eoi',
    },
    {
      label: 'Matrix',
      routerLink: '/project_/matrix',
      icon: menuItems?.matrix_icon,
      permissions: ['matrix_builder.manage'],
      flag: 'matrix',
    },
    {
      label: 'Matrix (classic)',
      routerLink: '/project_/sale-board-list',
      icon: menuItems?.matrix_icon,
      permissions: ['matrix_builder.manage'],
      flag: 'matrix',
    },
    {
      label: 'Precinct Set up',
      routerLink: '/listings/project-precinct',
      icon: commonImages?.project_1_icon,
      permissions: ['project_precinct.view'],
      flag: 'precinct_set_up',
    },
  ],
  sale: [
    // Sale related menu items

    {
      label: 'Overview',
      routerLink: '/report/overview',
      icon: menuItems?.listing_report_icon,
      permissions: [],
      flag: 'report_sales',
      // Login activity dashboard — restricted to these roles (backend 403s others).
      roles: ['master admin', 'operations manager'],
    },
    {
      label: 'User Activity',
      routerLink: '/report/user-activity',
      icon: menuItems?.member_ship_icon,
      permissions: [],
      flag: 'user_activity',
      // Team leaders see it too, and that isn't a role — shown only when GET /user-activity/access says so.
      userActivityAccess: true,
    },
    {
      label: 'Company Performance',
      routerLink: '/report/company-performance',
      icon: menuItems?.report_icon,
      permissions: ['report.manage', 'report.view'],
      flag: 'company_performance_report',
    },
    {
      label: 'Reports',
      routerLink: '/report/reports',
      icon: menuItems?.report_icon,
      permissions: ['report.manage', 'report.view'],
      flag: 'reports',
    },
    {
      label: 'Create Report',
      routerLink: '/report/create-report',
      icon: menuItems?.create_report_icon,
      permissions: ['report.manage', 'report.view'],
      flag: 'create_report',
    },
    {
      label: 'Project Sales Report',
      routerLink: '/report/my-sales',
      icon: menuItems?.create_report_icon,
      permissions: ['report.manage', 'report.view'],
      flag: 'report_sales',
    },
    // {
    //   label: 'Listing Sales Report',
    //   routerLink: '/report/listing-sales',
    //   icon: menuItems?.listing_report_icon,
    //   permissions: [],
    //   flag: 'report_sales',
    // },
    {
      label: 'KPIs',
      routerLink: '/report/kpi',
      icon: menuItems?.kpi_icon,
      permissions: ['kpi.manage', 'kpi.view'],
      flag: 'kpi',
    },
    {
      label: 'KPI Leaderboard',
      routerLink: '/report/kpi-board',
      icon: menuItems?.kpi_board,
      permissions: ['kpi.manage', 'kpi.view'],
      flag: 'kpi_leaderboard',
    },
  ],
  listing: [
    // Listing related menu items
    {
      label: 'Listing',
      routerLink: '/listings/listing-properties',
      icon: 'pi pi-list f-10 mr-2',
      img: null,
      flag: 'listing',
    },
    {
      label: 'Properties',
      routerLink: '/property/properties',
      icon: null,
      img: commonImages?.home_icon,
      flag: 'properties',
    },
    {
      label: 'Approval',
      routerLink: '/listings/listing-approval',
      icon: null,
      img: menuItems?.check_one_icon,
      flag: 'approval',
    },
    {
      label: 'OFI',
      routerLink: '/ofi/ofi-list',
      icon: null,
      img: commonImages?.home_icon,
      flag: 'ofi',
    },
    {
      label: 'Reporting',
      routerLink: '/listings/listing-report',
      icon: null,
      // Not `home_icon` — Properties above already uses it, and two tabs sharing a glyph
      // makes the row unreadable at a glance.
      img: menuItems?.listing_report_icon,
      flag: 'listingDashboardReporting',
    },
  ],
};
